import script from "./HelpCenter.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpCenter.vue?vue&type=script&lang=ts&setup=true"

import "./HelpCenter.vue?vue&type=style&index=0&id=7d806798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d806798"]])

export default __exports__